namespace SolovisGateway.Admin.Users {

    /**
     * Confirmation dialog for resetting a user's failed login streak lockout.
     *
     * UserResetFailedLoginStreakDialog.showDialog({ userId, email?, saveCallback? }):
     *   - userId:       the Gateway user whose failed-login lockout is reset (required).
     *   - email:        optional label for the confirmation message; falls back to "this user".
     *   - saveCallback: optional, invoked after a successful reset (e.g. to show a success toast).
     */
    export class UserResetFailedLoginStreakDialog {

        private _userId;
        private _email;
        private _saveCallback;
        private _dialogWindow;
        private _messageDiv;

        constructor(options) {
            var self = this;

            this._userId = options.userId ? options.userId : null;
            this._email = options.email ? options.email : null;
            this._saveCallback = options.saveCallback ? options.saveCallback : null;

            var desiredWidth = Math.min($(window).width() * .8, 480);
            var desiredHeight = Math.min($(window).height() * .8, 220);

            var target = this._email ? this._email : "this user";

            var bodyDiv = $("<div>")
                .css("min-height", "60px");

            $("<div>")
                .text("Reset the failed login streak for " + target + "? This clears any lockout so they can sign in again immediately.")
                .appendTo(bodyDiv);

            this._messageDiv = $("<div>")
                .css({ "display": "none", "margin-top": "10px", "color": "#c62828" })
                .appendTo(bodyDiv);

            this._dialogWindow = new Solovis.UI.Dialog({
                container: bodyDiv,

                title: "Reset Failed Login Streak",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: 100,
                minHeight: 100,
                height: desiredHeight,
                buttons: [
                    {
                        label: "Reset Failed Login Streak",
                        click: function () {
                            self._reset();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialogWindow.close();
                        }
                    }
                ]
            });
        }

        public _reset() {
            var self = this;

            self._messageDiv.hide();

            Solovis.Rpc.invokeAndWait("~/Admin/UserAdmin/ResetFailedLoginStreak",
                {
                    userId: this._userId
                },
                function (response, success) {
                    var modelState = response ? response.result : null;
                    if (success && modelState && modelState.modelIsValid !== false) {
                        self._dialogWindow.close();
                        if (self._saveCallback) {
                            self._saveCallback();
                        }
                    }
                    else {
                        self._showError(self._extractErrorMessage(response));
                    }
                });
        }

        private _extractErrorMessage(response) {
            var modelState = response ? response.result : null;
            if (modelState && modelState.errors && modelState.errors.length) {
                return modelState.errors[0].message ? modelState.errors[0].message : "Failed to reset failed login streak. Please try again.";
            }
            if (response && response.error && response.error.message) {
                return response.error.message;
            }
            return "Failed to reset failed login streak. Please try again.";
        }

        private _showError(message) {
            this._messageDiv
                .css("display", "block")
                .empty()
                .append($("<span>").addClass("fa fa-exclamation-circle").css("margin-right", "6px"))
                .append($("<span>").text(message));
        }

        public static showDialog(options) {
            return new SolovisGateway.Admin.Users.UserResetFailedLoginStreakDialog(options);
        }
    }
}
